<app-modal *ngIf="vo$ | async; let vo" class="consumer-mapping-popup">
	<div modal-body class="consumer-mapping-popup__body">
		<div class="consumer-mapping-popup__info">
			<dc-alert
				[type]="'info'"
				message="message"
				i18n-message="@@exposition.access.consumer.mapping.popup.details"></dc-alert>
		</div>

		<div
			class="consumer-mapping-popup__selected-consumers"
			[class.no-selection]="vo.selectedConsumers.length === 0">
			<div
				*ngIf="vo.selectedConsumers.length !== 0"
				class="consumer-selection-chips">
				<app-chip
					*ngFor="let item of vo.selectedConsumers"
					viewMode="default"
					(remove)="removeSelectedConsumer(item.id)">
					<mat-icon
						*ngIf="item.isGroup"
						[svgIcon]="DcIcons.Group"
						app-chip-icon></mat-icon>
					<app-avatar
						*ngIf="!item.isGroup && item.avatar"
						[avatar]="item.avatar"
						app-chip-icon></app-avatar>
					<span>{{ item.name }}</span>
				</app-chip>
			</div>
			<div
				*ngIf="vo.selectedConsumers.length === 0"
				class="consumer-selection-area">
				<span i18n="@@exposition.access.consumer.mapping.popup.no-selection">
					no-selection
				</span>
			</div>
		</div>

		<div class="consumer-mapping-popup__consumers">
			<app-toggle-buttons [actions]="consumerTypes"></app-toggle-buttons>
			<app-panel
				headerHeight="3.25rem"
				isAlwaysOpen="true"
				hasSearchableGrid="true"
				hasRefresh="true"
				maxActionsCount="6"
				[itemsCount]="vo.consumerList.elements.size"
				(refresh)="refresh()"
				(search)="search($event)">
				<div panel-title class="app-panel__title">
					<ng-container *ngIf="vo.consumerType === ConsumerType.User">
						<mat-icon [svgIcon]="DcIcons.User"></mat-icon>
						<span i18n="@@exposition.access.consumer.type.users">
							users
						</span>
					</ng-container>

					<ng-container *ngIf="vo.consumerType === ConsumerType.Group">
						<mat-icon [svgIcon]="DcIcons.Group"></mat-icon>
						<span i18n="@@exposition.access.consumer.type.groups">
							groups
						</span>
					</ng-container>
				</div>
				<dx-data-grid
					[elementAttr]="{
						id: 'access-consumer-list',
						class: 'consumer-list'
					}"
					[dataSource]="vo.consumerList.elements | toArray"
					keyExpr="id"
					[filterRow]="{ visible: true, applyFilter: 'auto' }"
					[headerFilter]="{ visible: true }"
					[hoverStateEnabled]="true"
					[showColumnHeaders]="true"
					[allowColumnResizing]="true"
					[columnAutoWidth]="false"
					[showRowLines]="false"
					[showColumnLines]="false"
					[rowAlternationEnabled]="false"
					[showBorders]="false"
					[width]="'100%'"
					[repaintChangesOnly]="true"
					(onContentReady)="onGridContentReady($event)"
					(onSelectionChanged)="onSelectionChanged()">
					<dxo-selection
						mode="multiple"
						selectAllMode="page"
						showCheckBoxesMode="always"></dxo-selection>

					<dxo-header-filter [visible]="true"></dxo-header-filter>

					<dxo-load-panel
						shadingColor="rgba(0,0,0,0)"
						[indicatorSrc]="DcLoaders.LoaderInfinite"
						[height]="100"
						[width]="100"
						[enabled]="true"
						[showIndicator]="true"
						[showPane]="true"
						[shading]="true"></dxo-load-panel>

					<dxo-column-fixing [enabled]="true"></dxo-column-fixing>

					<ng-container
						*ngFor="let col of vo.consumerList.availableColumns | toArray">
						<dxi-column
							*ngIf="col.field === 'name'"
							[dataField]="col.field"
							[dataType]="col.type"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[fixed]="false"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"
							[visible]="col.visible"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable"
							[allowSorting]="col.canBeReordered"
							[allowHeaderFiltering]="col.hasHeaderFilter"
							[filterOperations]="StringFilterOperations"
							[format]="col.format"
							[alignment]="'left'"
							[visibleIndex]="col.visibleIndex"
							[width]="'20%'"
							cellTemplate="nameTemplate"></dxi-column>

						<dxi-column
							*ngIf="col.field === 'lastName'"
							[dataField]="col.field"
							[dataType]="col.type"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[fixed]="false"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"
							[visible]="col.visible"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable"
							[allowSorting]="col.canBeReordered"
							[allowHeaderFiltering]="col.hasHeaderFilter"
							[filterOperations]="StringFilterOperations"
							[format]="col.format"
							[alignment]="'left'"
							[visibleIndex]="col.visibleIndex"
							[width]="'15%'"></dxi-column>

						<dxi-column
							*ngIf="col.field === 'firstName'"
							[dataField]="col.field"
							[dataType]="col.type"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[fixed]="false"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"
							[visible]="col.visible"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable"
							[allowSorting]="col.canBeReordered"
							[allowHeaderFiltering]="col.hasHeaderFilter"
							[filterOperations]="StringFilterOperations"
							[format]="col.format"
							[alignment]="'left'"
							[visibleIndex]="col.visibleIndex"
							[width]="'15%'"></dxi-column>

						<dxi-column
							*ngIf="col.field === 'mail'"
							[dataField]="col.field"
							[dataType]="col.type"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[fixed]="false"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"
							[visible]="col.visible"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable"
							[allowSorting]="col.canBeReordered"
							[allowHeaderFiltering]="col.hasHeaderFilter"
							[filterOperations]="StringFilterOperations"
							[format]="col.format"
							[alignment]="'left'"
							[visibleIndex]="col.visibleIndex"
							[width]="'20%'"></dxi-column>

						<dxi-column
							*ngIf="col.field === 'description'"
							[dataField]="col.field"
							[dataType]="col.type"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[fixed]="false"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"
							[visible]="col.visible"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable"
							[allowSorting]="col.canBeReordered"
							[allowHeaderFiltering]="col.hasHeaderFilter"
							[filterOperations]="StringFilterOperations"
							[alignment]="'left'"
							[visibleIndex]="col.visibleIndex"
							[width]="'25%'"></dxi-column>
					</ng-container>

					<div class="name-template" *dxTemplate="let cell of 'nameTemplate'">
						<ng-container *ngIf="!cell.data['isGroup']">
							<app-avatar
								*ngIf="cell.data['avatar']"
								[avatar]="cell.data['avatar']"
								[withTooltip]="true"></app-avatar>
						</ng-container>
						<span>
							{{ cell.data['name'] }}
						</span>
					</div>

					<div *dxTemplate="let cell of 'creationDateTemplate'">
						<span *ngIf="cell.data['creationDate']">
							{{ cell.data['creationDate'] | dayjsDate: 'DateTime' }}
						</span>
					</div>

					<div *dxTemplate="let cell of 'updateDateTemplate'">
						<span *ngIf="cell.data['updateDate']">
							{{ cell.data['updateDate'] | dayjsDate: 'DateTime' }}
						</span>
					</div>

					<dxo-group-panel [visible]="false"></dxo-group-panel>

					<!-- Filterable columns	-->
					<dxo-filter-row
						[visible]="
							vo.consumerList.availableColumns.size !== 0
						"></dxo-filter-row>

					<!-- Sorting	-->
					<dxo-sorting mode="multiple"></dxo-sorting>

					<!-- Pagination -->
					<dxo-paging [pageSize]="20" [pageIndex]="0"></dxo-paging>
					<dxo-pager
						[visible]="true"
						[showPageSizeSelector]="true"
						[allowedPageSizes]="allowedPageSizes"
						[showInfo]="true"
						[showNavigationButtons]="true"></dxo-pager>

					<dxo-filter-panel [visible]="true"></dxo-filter-panel>
				</dx-data-grid>
			</app-panel>
		</div>
	</div>
	<div modal-footer class="consumer-mapping-popup__footer">
		<button
			id="{{ cmpId }}-save-btn"
			class="consumer-mapping-popup__footer__btn"
			[color]="'primary'"
			[disabled]="vo.selectedConsumers.length === 0"
			(click)="saveAction()"
			mat-raised-button>
			<span i18n="@@general.action.save">save</span>
		</button>
	</div>
</app-modal>
